import { render, staticRenderFns } from "./SettingSubscriptionModal.vue?vue&type=template&id=33202785&scoped=true"
import script from "./SettingSubscriptionModal.vue?vue&type=script&lang=ts"
export * from "./SettingSubscriptionModal.vue?vue&type=script&lang=ts"
import style0 from "./SettingSubscriptionModal.vue?vue&type=style&index=0&id=33202785&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33202785",
  null
  
)

export default component.exports